import { handleApiError } from 'utils/api';
import { env } from '../../constants';
import { CreateReasonFormData, ReasonDetailsResponse } from './types';

export const fetchReason = async (
  token: string | undefined,
  reasonId: string | undefined
): Promise<ReasonDetailsResponse | undefined> => {
  if (!token || !reasonId) {
    return undefined;
  }

  const response = await fetch(`${env.VITE_API_BASE_URL}/reasons/${reasonId}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  if (!response.ok) {
    if ([401, 503].includes(response.status)) {
      window.location.reload();
    }
    return undefined;
  }

  return response.json() as Promise<ReasonDetailsResponse>;
};

export const createReason = async (
  token: string | undefined,
  formData: CreateReasonFormData
): Promise<null | undefined> => {
  if (!token || !formData.periodRefId) {
    return undefined;
  }

  const response = await fetch(`${env.VITE_API_BASE_URL}/reasons`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  });

  if (!response.ok) {
    if ([401, 503].includes(response.status)) {
      window.location.reload();
    }
    if (response.status === 400) {
      await handleApiError(response);
    } else throw Error('Could not create reason');
  }

  return null;
};

export const deleteReason = async (
  token: string | undefined,
  refId: string | undefined
): Promise<null | undefined> => {
  if (!token || !refId) {
    return undefined;
  }

  const response = await fetch(`${env.VITE_API_BASE_URL}/reasons/${refId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    if ([401, 503].includes(response.status)) {
      window.location.reload();
      return undefined;
    }
    if (response.status === 400) {
      await handleApiError(response);
    } else throw Error('Could not delete reason');
  }

  return null;
};
